module.exports = __webpack_public_path__ + "static/img/Dog.a76d6f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_animal/Dog.svg
// module id = 1358
// module chunks = 0